import lang from "@/views/modules/MultiBranchs/language/en";
import tinymce from 'vue-tinymce-text-editor';


export default {
    name: "new-email-template",
   
    components: {
        'tinymce': tinymce,
    },
    data() {
        return {
            loading: true,
            showDropdown: null,
            multibranchObj: {
                record:'',
                branch_id:'',
                branch_name:'',
                user_id:'',
                user_name:'',
                username:'',
                users:[],
            },
            error_message:{},
            process:false,
            lang:[],
            user_error:'',
            branch_error:'',
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        addUser(){
            this.user_error = '';
            const existingUser = this.multibranchObj.users.find(item=> item.user_id == this.multibranchObj.user_id);
            if (existingUser) {
                this.user_error = 'User already added';
                return;
            }
            let user = {
                'branch_id': this.multibranchObj.branch_id,
                'branch_name': this.multibranchObj.branch_name,
                'user_id': this.multibranchObj.user_id,
                'user_name': this.multibranchObj.user_name,
                'username': this.multibranchObj.username,
            }
            
            this.multibranchObj.users.push(user);
            this.multibranchObj.user_id = '';
            this.multibranchObj.user_name = '';
            this.multibranchObj.username = '';
        },
        removeUser(i){
            this.multibranchObj.users.splice(i, 1);
        },
        SaveMultiBranch(){
            const self = this;
            self.loading = true;
            if(self.user_error == '' && self.branch_error == ''){
                axios.post('api/modules/multibranchs', self.multibranchObj).then(function (response) {
                    self.loading = false;
                    self.$router.push('/modules/multibranchs');
                }).catch(function () {
                    self.loading = false;
                });
            }
        },
        getMultiBranchInfo(branch_id = ''){
            const self = this;
                window.currentAction = 'add';
                self.branch_error = '';
            if(branch_id != ''){
                axios.get('api/modules/multibranchs/axioscall', {params:{'getBranchInfo':true, 'branch_id':branch_id}}).then(function (response) {
                    if(response.data.message != ''){
                        self.branch_error = response.data.message
                    }
                }).catch(function () {

                });
            }
        },
        openComponent(routeName, moduleName, field_id, queryData = null) {
            this.field_id = field_id;
            this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&moduleName=${moduleName}`, "", "width=900,height=400,left=200,top=200");
            this.parentCompnent = routeName;
            this.windowRef.addEventListener('beforeunload', this.parentMethod);

        },
        parentMethod() {
            const module_name = this.parentCompnent.slice(0, -1);
            const parent_id = localStorage.getItem('parentid');
            const parent_name = localStorage.getItem('parentname');
            const parent_type = localStorage.getItem('parenttype');
            const parentObj = JSON.parse(localStorage.getItem('parentObj'));
            this.selectElement(module_name, parent_name, parent_id, parent_type);

            if (this.windowRef) {
                this.windowRef.close();
                this.windowRef = null;
                this.$emit('close');
            }

            if(parent_type == 'user'){
                this.multibranchObj.username = parentObj.user_name;
            }
                        
            localStorage.removeItem('parentid');
            localStorage.removeItem('parentname');
            localStorage.removeItem('parenttype');

        },
        updateItem(id, name, type, itemObj) {
            this.showDropdown = false;
            const module_name = type;
            if(module_name == 'user'){
                this.multibranchObj.username = itemObj.user_name;
            }
            this.selectElement(module_name, name, id, type);            
        },
        selectElement(moduleName, name = null, id = null, module = null, moduleObj) {

            const module_name = moduleName.replace("-", "_");
            const p_name = module_name + '_name';
            const p_name_el = document.getElementById(p_name);
           
            p_name_el.value = name;
            p_name_el.dispatchEvent(new Event('input'));
            const p_id = this.field_id;
            const p_id_el = document.getElementById(p_id);
            p_id_el.value = id;
            p_id_el.dispatchEvent(new Event('input'));
            //this.field_id = null;
           
            if(moduleName == 'branch'){
                this.getMultiBranchInfo(id);
            }

        },
        clearComponent(modulesLink) {
            const self = this;
            self.dropdownList = [];
            if (self.dropdownList.length == 0) {
                self.selectElement(modulesLink, '', '', '');
            }
        },
        queryForKeywords(e, modulesLink, field_id) {
            const self = this;
            self.field_id = field_id;
            let searchData = e.target.value;
            let relatedModule = modulesLink + 's';
            self.showDropdown = null;

            if (searchData.length > 0) {
                axios.post(`api/modules/searchItem`, { 'data': searchData, 'relatedModule': relatedModule }).then(function (response) {
                    self.dropdownList = response.data;
                    self.showDropdown = field_id;
                });
            } else {
                self.showDropdown = false;
                self.dropdownList = [];

                if (searchData.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }

            }
        },
    }
}